import { render, staticRenderFns } from "./AamsUnitRegInfoBankDetail.vue?vue&type=template&id=8c66191a&scoped=true&"
import script from "./AamsUnitRegInfoBankDetail.vue?vue&type=script&lang=js&"
export * from "./AamsUnitRegInfoBankDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsUnitRegInfoBankDetail.vue?vue&type=style&index=0&id=8c66191a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c66191a",
  null
  
)

export default component.exports